import {
    CREATE_RECEIVE_SETS_SUCCESS,
    SAVE_RECEIVE_SETS_DETAILS,
    createReceiveSetsFailure,
    bulkBarcodeDetailsData,
    BULK_EXCLUDED_POPUP_DATA,
} from '../actions';

import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { removeEmptyFieldsFromObject } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* createReceiveSets(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/inventory/transfersets/return`;
    const isManual = action.payload.isManual;
    const isBulkAdd = action.payload.isBulkAdd;
    const isSetAndBatch = action.payload.isSetAndBatch;
    // const isFromBarcode = action.payload.isFromBarcode;

    const setNo = action.payload.sets[0].setNo;
    const batchNo = action.payload.sets[0].batchNo;
    const isFoundDuplicate = action.payload.isFoundDuplicate;
    const payload = removeEmptyFieldsFromObject(action.payload);
    const bulkExcludedData = yield select(
        (state) => state.receiveSetsListDataReducer.bulkExcludedData
    );

    try {
        const result = yield axios
            .post(url, payload)
            .then((response) => response.data);
        // const modify_result = {
        //     ...result,
        //     isSubmitted,
        // };
        // if (result && result.statusCode === '200') {
        if (result.statusCode === '10830' || result.statusCode === '10734') {
            yield put({
                type: CREATE_RECEIVE_SETS_SUCCESS,
                data: result,
            });
        } else {
            if (payload.isSubmit === false) {
                result.isFoundDuplicate = isFoundDuplicate;
                // result.isFromBarcode = isFromBarcode;
                yield put({
                    type: CREATE_RECEIVE_SETS_SUCCESS,
                    data: result,
                });
                yield put({
                    type: SAVE_RECEIVE_SETS_DETAILS,
                    payload: payload.dataList,
                });
            } else {
                yield put({
                    type: CREATE_RECEIVE_SETS_SUCCESS,
                    data: result,
                });
            }
        }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        error.response.data.isManual = isManual;
        // error.response.data.isFromBarcode = isFromBarcode;
        if (isSetAndBatch) {
            error.response.data.setNo = setNo;
            error.response.data.batchNo = batchNo;
        }
        payload['validatedData']= error.response.data?.statusCode;

        let newArray = [];
        if(isBulkAdd && (error.response.data?.statusCode === '10830' || error.response.data?.statusCode === '10734')){
            
            bulkExcludedData?.push(payload);      
            newArray = [...bulkExcludedData];
            // const getUniqueBarcode = [
            //     ...new Map(
            //         newArray.map((item) => [item['barcode'], item])
            //     ).values(),
            // ];
            // yield put({
            //     type: BULK_EXCLUDED_POPUP_DATA,
            //     data: getUniqueBarcode,
            // });
        }
        
        localStorage.setItem(
            'createReceiveSetError',
            JSON.stringify(error.response.data?.statusCode)
        );
        yield put(createReceiveSetsFailure({ data: error.response.data }));
    }
}
